module.exports = __webpack_public_path__ + "img/txp4.29c59e74.jpg";